import React from "react";
import { connect } from "react-redux";
import * as questionActions from "../redux/actions/questionActions";
import { useHistory } from "react-router-dom";
import { generateUID } from "../utils/api";

function AddQuestion(props: { isLogged: boolean; loggedUser: { id: any; }; addNewQuestion: (arg0: { author: any; option1: any; option2: any; questionId: any; }) => void; }) {
  const history = useHistory();
  if (props.isLogged === false) {
    history.push("/login");
  }
  function addQuestion() {
    const author = props.loggedUser.id;
    let option1:any = document.getElementById("option1");
    option1 = option1.value;
    let option2:any = document.getElementById("option2");
    option2 = option2.value;
    if (option1.length === 0 || option2.length === 0) return;
    const questionId = generateUID();
    props.addNewQuestion({ author, option1, option2, questionId });
    history.push("/");
  }
  return (
    <div className="row justify-content-center">
      <div className="container card1 col-4">
        <div className="row col-12 title_bg">Create New Question</div>
        <div className="row">
          <div className="col-12 center">
            <p className="title">Would You Rather</p>
            <input
              id="option1"
              type="text"
              className="content center"
              placeholder="Enter Option One text here"
              style={{ width: "65%" }}
            />
            <p className="content center">or</p>
            <input
              id="option2"
              type="text"
              className="content center"
              placeholder="Enter Option Two text here"
              style={{ width: "65%" }}
            />
          </div>
        </div>
        <div className="row viewBtn">
          <div className="col-3"></div>
          <button
            onClick={() => addQuestion()}
            className="btn alert-primary btn-sm col-6"
          >
            Submit
          </button>
          <div className="col-3"></div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: { questionReducer: { allQuestions: any; }; userReducer: { users: any; loggedUser: { id: any; }; }; }) => {
  return {
    allQuestions: state.questionReducer.allQuestions,
    users: state.userReducer.users,
    loggedUser: state.userReducer.loggedUser,
    isLogged: state.userReducer.loggedUser.id ? true : false,
  };
};

const mapDispatchToProps = (dispatch:any) => {
  return {
    addNewQuestion: (info:any) => dispatch(questionActions.addNewQuestion(info)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddQuestion);
